import { useBaseApplicationTranslation as n } from "../../../shared/libraries/local-translations/index.js";
import { defineComponent as r, ref as a } from "vue";
import s from "../../../search/ui/components/available_contracts/index.js";
const l = r({
  name: "SearchModalMobile",
  props: {
    config: {
      type: Object,
      required: !0
    }
  },
  components: {
    ContractsSearch: s
  },
  setup() {
    const o = a(!1), e = function() {
      o.value = !o.value;
    }, { t } = n();
    return {
      showModal: o,
      toggleModal: e,
      t
    };
  }
});
export {
  l as default
};
//# sourceMappingURL=index39.js.map
